export var defaultBreakpoints = ['400px', '600px', '900px', '1200px', '1500px'];
//# sourceMappingURL=defaultBreakpoints.js.map